(function () {
  var GROUPS = ["type", "brand", "fam", "fab", "weight"], busy = false;
  function recount() {
    var S = window.S, box = document.getElementById("groups");
    if (!S || !box || typeof window.filtered !== "function" || busy) return;
    busy = true;
    try {
      Array.prototype.forEach.call(box.querySelectorAll(".opt"), function (o) {
        var g = o.dataset.g, k = o.dataset.k;
        if (GROUPS.indexOf(g) < 0 || !S[g]) return;
        var keep = S[g], n = 0, one = {};
        one[k] = 1;
        S[g] = one;
        try { n = window.filtered().length; } catch (e) {} finally { S[g] = keep; }
        var c = o.querySelector(".n");
        if (c && c.textContent !== String(n)) c.textContent = String(n);
        var on = !!keep[k];
        o.style.display = n || on ? "" : "none";
        o.style.opacity = "";
      });
    } finally { busy = false; }
  }
  function start() {
    var r = window.render;
    if (!window.S || typeof r !== "function" || typeof window.filtered !== "function" || !document.getElementById("groups")) return false;
    if (document.getElementById("reqPage") || document.querySelector("#rvaCat.rva-style-page")) return true;
    if (r.rvaFacets) return true;
    var g = function () { var out = r.apply(this, arguments); try { recount(); } catch (e) {} return out; };
    g.rvaFacets = 1;
    window.render = g;
    recount();
    return true;
  }
  if (!start()) {
    var tries = 0, iv = setInterval(function () { if (start() || ++tries > 200) clearInterval(iv); }, 50);
  }
})();

(function () {
  var VIEW = /[#&](?:type|view|t)=(?:womens|women|women-s|ladies|youth|youths|kids)(?:&|$)/i;
  function closeMenus() {
    Array.prototype.forEach.call(document.querySelectorAll(".header__inline-menu details[open]"), function (d) {
      var hm = d.closest ? d.closest("header-menu") : null;
      if (hm && typeof hm.close === "function") { try { hm.close(); return; } catch (e) {} }
      d.removeAttribute("open");
    });
    var drawer = document.querySelector("header-drawer");
    if (drawer && typeof drawer.closeMenuDrawer === "function") {
      var open = drawer.querySelector("details[open]");

      if (open) { try { drawer.closeMenuDrawer({ target: drawer }, drawer.querySelector("summary") || drawer); } catch (e) { open.removeAttribute("open"); } }
    }
  }
  window.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!a) return;
    var href = a.getAttribute("href") || "", i = href.indexOf("#");
    var path = href.slice(0, i).replace(/^https?:\/\/[^\/]+/, "");
    if ((path && path !== location.pathname) || !VIEW.test(href.slice(i))) return;
    setTimeout(closeMenus, 0);
  }, true);
})();

(function () {
  var MENU = /[#&](?:type|brand|view|t)=/i, SEARCH = /[#&](?:q=|search(?:&|$))/i, lockUntil = 0;
  function locked() { return Date.now() < lockUntil; }
  function isCat() { return !!document.getElementById("groups") && !!document.getElementById("grid") && !document.getElementById("reqPage") && !document.querySelector("#rvaCat.rva-style-page"); }
  var oTo = window.scrollTo, oSIV = Element.prototype.scrollIntoView;
  function top(smooth) { try { oTo.call(window, { top: 0, behavior: smooth ? "smooth" : "auto" }); } catch (e) { oTo.call(window, 0, 0); } }
  window.scrollTo = function (a, b) {
    if (locked()) { var y = a && typeof a === "object" ? a.top : b; if (y) return; }
    return oTo.apply(window, arguments);
  };
  Element.prototype.scrollIntoView = function () {
    if (locked() && this.closest && this.closest("#rvaCat")) return;
    return oSIV.apply(this, arguments);
  };
  function menuHash(h) { return MENU.test(h) && !SEARCH.test(h); }

  window.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || !isCat()) return;
    var href = a.getAttribute("href") || "", i = href.indexOf("#");
    var path = href.slice(0, i).replace(/^https?:\/\/[^\/]+/, "");
    if ((path && path !== location.pathname) || !menuHash(href.slice(i))) return;
    lockUntil = Date.now() + 1200;
    setTimeout(function () { top(true); }, 0);
  }, true);

  var back = false;
  try { var nav = performance.getEntriesByType("navigation")[0]; back = !!nav && nav.type === "back_forward"; } catch (e) {}
  if (!back && menuHash(location.hash) && isCat()) {
    lockUntil = Date.now() + 2500;
    top(false);
    document.addEventListener("DOMContentLoaded", function () { top(false); });
  }

  function on(o) { if (o) for (var k in o) if (o[k]) return true; return false; }
  function mixOn(S) { return !!S && isCat() && on(S.brand) && !on(S.wv) && !on(S.yv); }
  var NOTES = {
    wy: ["Ordering women's or youth sizes too?", " Women's and youth shirts are cut smaller, so the design is resized to fit them and each is treated as a separate order, priced on its own quantity."],
    w: ["Ordering women's and unisex together?", " Women's shirts are cut smaller, so the design is resized to fit them and they're treated as a separate order. Women's pieces are priced on their own quantity."],
    y: ["Ordering youth and adult sizes together?", " Youth shirts are smaller, so the design is resized to fit them and they're treated as a separate order. Youth pieces are priced on their own quantity."]
  };
  function brandNote() {
    var S = window.S, grid = document.getElementById("grid"), n = document.getElementById("rvaBrandNote"), key = "";
    if (grid && mixOn(S)) {
      var w = false, y = false;
      try { window.filtered().forEach(function (s) { if (s.w) w = true; if (s.y) y = true; }); } catch (e) {}
      key = w && y ? "wy" : w ? "w" : y ? "y" : "";
    }
    if (!key) { if (n && n.parentNode) n.parentNode.removeChild(n); return; }
    if (!n) { n = document.createElement("p"); n.id = "rvaBrandNote"; n.className = "ythNote ythNote--grid"; n.setAttribute("role", "note"); }
    if (n.getAttribute("data-k") !== key) { n.setAttribute("data-k", key); n.innerHTML = "<strong>" + NOTES[key][0] + "</strong>" + NOTES[key][1]; }
    if (n.parentNode !== grid.parentNode || n.nextSibling !== grid) grid.parentNode.insertBefore(n, grid);
  }
  function start() {
    var S = window.S, r = window.render, f = window.filtered;
    if (!S || !S.wv || !S.yv || typeof r !== "function" || typeof f !== "function" || !r.rvaFacets) return false;
    if (f.rvaMix) return true;
    var g = function () {
      var S = window.S;
      if (!mixOn(S)) return f.apply(this, arguments);
      var kw = S.wv, ky = S.yv, all = [], self = this, args = arguments;
      function add(list) { list.forEach(function (s) { if (all.indexOf(s) < 0) all.push(s); }); }
      try {
        add(f.apply(self, args));
        S.wv = { womens: 1 }; S.yv = {}; add(f.apply(self, args));
        S.wv = {}; S.yv = { youth: 1 }; add(f.apply(self, args));
      } finally { S.wv = kw; S.yv = ky; }
      return all;
    };
    g.rvaMix = 1;
    window.filtered = g;
    var rr = function () { var out = r.apply(this, arguments); try { brandNote(); } catch (e) {} return out; };
    rr.rvaFacets = 1;
    window.render = rr;
    window.render();
    return true;
  }
  if (isCat() && !start()) {
    var tries = 0, iv = setInterval(function () { if (start() || ++tries > 200) clearInterval(iv); }, 50);
  }
})();